var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRoomBackArrow = function SvgRoomBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 34,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M15.403 32.654 2.839 23.7a1.03 1.03 0 0 1-.426-.734L.88 7.865c-.046-.452.21-.881.63-1.055L15.607.975c.252-.105.535-.105.787 0L30.49 6.81c.42.174.676.603.63 1.055l-1.533 15.102c-.03.295-.185.562-.426.734l-12.564 8.953a1.03 1.03 0 0 1-1.194 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m18 10-6 6 6 6"
  })));
};
export default SvgRoomBackArrow;